export default {
  jpath: ['general'],
  getEmpty() {
    return {
      description: '',
      title: '',
      name: [],
      mf: '',
      molfile: '',
      mw: 0,
      keyword: [],
      meta: {},
      sequence: '',
      kind: '',
    };
  },
};
